import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-step-one',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './step-one.component.html',
  styleUrls: ['./step-one.component.scss']
})
export class StepOneComponent {
  @Output() phoneChange = new EventEmitter<string>();

  onPhoneInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.phoneChange.emit(`+56 ${input.value.substring(0, 1)}XXXXXXX`);
  }
}
